import {makeStyles} from '@material-ui/core/styles';

type Props = {
  isCollapsed: boolean;
};

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    minHeight: '100vh',
    paddingBottom: theme.spacing(14),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(0),
    },
  },
  swipableDrawerPaper: (props: Props) => ({
    backgroundColor: theme.palette.secondary.light,
    position: 'relative',
    width: `${props.isCollapsed ? '200px' : '200px'}`,
    [theme.breakpoints.up('md')]: {
      width: `${props.isCollapsed ? '260px' : '260px'}`
    }
  }),
  contentWrapper: (props: Props) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: theme.layout.containerPaddingHorizontal,
    paddingRight: theme.layout.containerPaddingHorizontal,
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      paddingTop: `calc(${theme.layout.headerHeight.mobile} + ${theme.spacing(3)}px)`
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(3)
    },
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${props.isCollapsed ? '260px' : '260px'})`,
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      paddingBottom: theme.spacing(4)
    }
  })
}));
